export default class UserLanguage {
  constructor (languageData) {
    this.id = languageData.id
    this.name = languageData.name
    this.isoCode = languageData.isoCode
  }
}
